




























































































































































import {Component, Prop, Watch, Mixins} from 'vue-property-decorator'
import {$, Helper, ID, MixinQueryRouter} from 'simpli-web-sdk'
import {DialogRemove} from '@/helpers/dialog/DialogRemove'
import {Motorista} from '@/model/resource/Motorista'
import {MotoristaCollection} from '@/model/collection/MotoristaCollection'
import {ListMotoristaSchema} from '@/schema/resource/Motorista/ListMotoristaSchema'
import {CsvMotoristaSchema} from '@/schema/resource/Motorista/CsvMotoristaSchema'
import {InputCheckbox} from 'simpli-web-sdk'
import {MixinSelect} from '@/components/mixins/MixinSelect'

@Component({
  components: {InputCheckbox},
})
export default class ListMotoristaView extends Mixins(
  MixinQueryRouter,
  MixinSelect
) {
  schema = new ListMotoristaSchema()
  collection = new MotoristaCollection()

  isSelecting = false // modo selecionando ou notificar todos
  selectedItems: Motorista[] = []
  notifyMessage = ''
  notifyOpen = false

  async created() {
    await this.query()
  }

  goToPersistView(item: Motorista) {
    Helper.pushByName('editMotorista', item.$id)
  }

  async removeItem(item: Motorista) {
    await new DialogRemove(item).confirm(() => item.removeMotorista())
    await this.collection.listMotorista()
  }

  async downloadXlsx() {
    const {ascending, orderBy, page, limit, ...params} = this.collection.params

    const collection = new MotoristaCollection()
      .clearFilters()
      .addFilter(params)

    await collection.listCsvMotorista()
    this.$xlsx.downloadFromSchema(
      collection.all(),
      new CsvMotoristaSchema(),
      $.t('schema.CsvMotorista.title') as string
    )
  }

  selectToNotify() {
    this.isSelecting = true
    this.notifyOpen = true
  }

  notifyAll() {
    this.isSelecting = false
    this.notifyOpen = true
    this.selectedResource = {}
  }

  cancelNotify() {
    this.isSelecting = false
    this.notifyOpen = false
    this.notifyMessage = ''
    this.selectedResource = {}
  }

  async sendMessage() {
    let driverIds: ID[] = []
    if (this.isSelecting) {
      if (!this.selectedItems.length) {
        this.$snotify.error(
          this.$t('schema.ListMotorista.emptyMotorista') as string
        )
        return
      }

      driverIds = this.selectedItems.map(driver => {
        return driver.$id
      })
    }

    await Motorista.notifyMotoristas(
      this.notifyMessage,
      driverIds,
      !this.isSelecting
    )

    this.$snotify.success(
      this.$t('schema.ListMotorista.successMessage') as string
    )
    this.cancelNotify()
  }
}
